import {BaseMobxStore} from "../../infrastructure/mobx/base-mobx-store";
import {CompetitorPlayersStatsModuleConfig} from "./competitor-players-stats-module.config";
import {CompetitorPlayersStatsModuleState} from "./models/competitor-players-stats-module.state";

export class CompetitorPlayersStatsModuleStore extends BaseMobxStore {
  static injectables = [CompetitorPlayersStatsModuleConfig, CompetitorPlayersStatsModuleState];
}